import { useTranslate } from "@similarweb/i18n-provider";

import CRMIntegrationsContainer from "app/pages/sales-intelligence/modules/manage-integrations/containers/CRMIntegrationsContainer";
import { CrmJobsTransitionBanner } from "app/pages/sales-intelligence/modules/industry/components/CrmJobsTransitionBanner/CrmJobsTransitionBanner";
import ManagementPageHeader from "app/pages/sales-intelligence/pages/management/components/ManagementPageHeader/ManagementPageHeader";

import withSecondaryBarSet from "../../../../hoc/withSecondaryBarSet";
import ManagementPageWrapper from "../../components/ManagementPageWrapper/ManagementPageWrapper";
import { MANAGEMENT_CRMS_AND_CONNECTORS } from "../../translations/managementKeys";

const ManageCRMsPageContainer = () => {
    const { translate } = useTranslate();

    return (
        <ManagementPageWrapper>
            <ManagementPageHeader text={translate(MANAGEMENT_CRMS_AND_CONNECTORS)} />

            <CrmJobsTransitionBanner />

            <CRMIntegrationsContainer />
        </ManagementPageWrapper>
    );
};

export default withSecondaryBarSet("SalesIntelligenceLists")(ManageCRMsPageContainer);
